import $ from 'jquery';
import language from '../js/language';
import { getUrlParam } from '../js/utils';
import './art-utils';
import index from './index/index'; // 首页
const art = {
  render() {
    // 渲染前设置模板语言
    // const targetLang = language.getLang();
    // 保证head只渲染一次
    if (!window.hasRenderHead) {
      window.hasRenderHead = true;
    }
    // header.render();

    index.render();
  },
};

export default art;
